import { client } from "../libs/client";

export const getAllPlans = async (region = "Nigeria") => {
  return await client.get("/plans", { params: { region } });
};

export const getPlanByType = async (planType, region = "Nigeria") => {
  return await client.get(`/plans/${planType}`, { params: { region } });
};

export const getUserPlanDetails = async () => {
  return await client.get("/user/plan-details");
};
